import type { IFeatureIslandCategoriesAndManagerStore } from "@/components/features/_layouts/island/main-with-category/store";
import { createFeatureIslandCategoryStore } from "@/components/features/_layouts/island/main-with-category/store/category";
import { createFeatureIslandCategoryManagerStore } from "@/components/features/_layouts/island/main-with-category/store/category-manager";

export class DummyRoomCategoriesAndManagerStore implements IFeatureIslandCategoriesAndManagerStore {
	// 基本設定
	public base = createFeatureIslandCategoryStore({
		title: "ダミー部屋名・画像",
		description: "ダミー部屋に関する基本的な設定を行う項目です",
		isBasicSetup: true,
	});

	public priceAndStockAndPolicy = createFeatureIslandCategoryStore({
		title: "定員・在庫・ポリシー",
		description: "",
		isBasicSetup: true,
	});

	public connection = createFeatureIslandCategoryStore({
		title: "プラン制限・紐付け",
		description: "",
		isBasicSetup: true,
	});

	// ここから下は 「追加設定」isBasicSetup: false
	// 「追加設定」：なし

	public categoryStoreArray = [
		this.base, //
		this.priceAndStockAndPolicy,
		this.connection,
	];

	public categoryManagerStore = createFeatureIslandCategoryManagerStore({
		items: this.categoryStoreArray,
	});
}

export const dummyRoomCategoriesAndManagerStore = new DummyRoomCategoriesAndManagerStore();
